import { Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import CarouselMedia from './CarouselMedia';
import { MediaSlides } from './types';

interface ICarouselContainerForDetails {
    title?: string // text needs to be added to i18n to work
    media: MediaSlides[];
    imageButtons?: boolean;
}

const CarouselContainerForDetails = ({ title, media, imageButtons }
  : ICarouselContainerForDetails) => {
  const { t } = useTranslation();

  
  return (
    <>
      <Stack>
        {title && 
        <Typography variant='h3' mb={2} >
          {t(title)}
        </Typography>
        }
        {media.length > 0 &&
        <Box sx={{
          width: '95%',
          height: '300px',
          margin: '0 auto',
        }}>
          <CarouselMedia slides={[...media]} imageButtons={imageButtons}/>
        </Box>
        }
      </Stack>
    </>
  );
};

export default CarouselContainerForDetails;